import IMask from "imask/esm/imask";
import "imask/esm/masked/number";
import { isAustraliaRegion } from "@/helpers/region/regionHelper.js";

export default {
  rate: {
    mask: Number,
    scale: 2,
    signed: false,
    thousandsSeparator: " ",
    padFractionalZeros: false,
    normalizeZeros: false,
    radix: ".",
    mapToRadix: ["."],
    validate(value) {
      return value <= 9999.99; // Validate that value is less than or equal to 999.99
    },
  },
  jobDate(lazy) {
    const isAustralia = isAustraliaRegion().value;
    return {
      lazy: lazy,
      mask: isAustralia ? "DD{/}MM{/}YYYY" : "MM{/}DD{/}YYYY",
      blocks: {
        YYYY: {
          mask: IMask.MaskedRange,
          from: new Date().getFullYear(),
          to: 3000,
        },
        MM: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 12,
        },
        DD: {
          mask: IMask.MaskedRange,
          from: 1,
          to: 31,
        },
      },
    };
  },
  abn: {
    mask: "00 000 000 000",
  },
  socialSecurityNumber: {
    mask: "000 - 00 0000",
  },
  identificationNumber: {
    mask: "000 - 0000000",
  },
  licenseText: {
    mask:  "aaa",
    prepare: function(str) {
      return str.toUpperCase();
    },
   
  },
  licenseNumber: {
    mask: "00000",
  },
  eprofileid: {
    mask: "000000[000]",
  },
  ahpraNumber: {
    mask: "aaa [0000000000]",
    // placeholderChar: ' ',
    prepare: function(str) {
      return str.toUpperCase();
    },
  },
  ahpraExpiryDate: {
    mask: "DD{/}MM{/}YYYY",

    // placeholderChar: ' ',
    blocks: {
      MM: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
      },

      DD: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
      },
      YYYY: {
        mask: IMask.MaskedRange,
        from: new Date().getFullYear(),
        to: 3000,
      },
    },
  },
  date: {
    mask: "DD{/}MM{/}YYYY",

    // placeholderChar: ' ',
    blocks: {
      MM: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
      },

      DD: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
      },
      YYYY: {
        mask: IMask.MaskedRange,
        from: new Date().getFullYear(),
        to: 3000,
      },
    },
  },

  vaccinationDate1: {
    mask: "DD{/}MM{/}YYYY",

    // placeholderChar: ' ',
    blocks: {
      MM: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
      },

      DD: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
      },
      YYYY: {
        mask: IMask.MaskedRange,
        from: new Date().getFullYear(),
        to: 3000,
      },
    },
  },


  bsb: {
    mask: "000000",
  },
  bankAccountNumber: {
    mask: "000000[000]",
    lazy: true,
    placeholderChar: " ",
  },
  payRate: {
    mask: Number,
    scale: 2,
    signed: false,
    padFractionalZeros: false,
    normalizeZeros: false,
    radix: ".",
    mapToRadix: ["."],
  },
};
